module.exports = __webpack_public_path__ + "img/android-fill.026de051.svg";